import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export default function ScrollToTop(setEnableScrollGA) {

		const checkScroll = (doAfter) => {
			// this runs a lot, checks to see if the page is scrolled up
			// if (window.pageYOffset === 0) {
			if (document.body.scrollTop === 0) {
				doAfter(); // <-- the callback, what you want to do after it arrives
			}
		};

		function scrollToTop(doAfter) {
			window.addEventListener('scroll', checkScroll); // this will fire a lot as it scrolls
			window.scrollTo(0, 0);
			document.getElementById("scrollTarget").scrollIntoView()
			checkScroll(doAfter); // run it in case already at top and there's no scroll
		}

		scrollToTop(() => {
			window.removeEventListener('scroll', checkScroll); // turn off this function
			window.setTimeout(() => {
				setEnableScrollGA(true);
			}, 0)
		})

	return null;
}
